import { Preferences } from '@capacitor/preferences'

export const authStorage = Preferences
